import { render } from "./ClientIntakeCouples.vue?vue&type=template&id=aa4b95fa&scoped=true"
import script from "./ClientIntakeCouples.vue?vue&type=script&lang=js"
export * from "./ClientIntakeCouples.vue?vue&type=script&lang=js"

import "./ClientIntakeCouples.vue?vue&type=style&index=0&id=aa4b95fa&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4b95fa"]])

export default __exports__